// index.js

import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";

import { Provider, useSelector } from "react-redux";
import "./service/i18/i18n";
import axios from "axios";
import { store } from "./Redux/store/index";

import App from "./App";

// Loader برای حالت بارگذاری lazy
const Loader = () => <div className="App">...</div>;

// بارگذاری تنبل (lazy) کامپوننت اصلی App

const OuterAppz = () => {



  // اگر نیاز دارید قبل از رندرگیری App مقداردهی یا فراخوانی API انجام دهید،
  // می‌توانید از useEffect استفاده کنید و یک پرچم canLoad را مدیریت کنید.
  // اینجا برای سادگی، App به صورت lazy load استفاده می‌شود.
  return (
    <Suspense fallback={<Loader />}>
      <Provider store={store}>
        <App />

      </Provider>
    </Suspense>
  );
};

export default OuterAppz;
